'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'chevrons-up';
var width = 512;
var height = 512;
var aliases = ["chevron-double-up"];
var unicode = 'f325';
var svgPathData = 'M267.3 52.7L256 41.4 244.7 52.7l-192 192L41.4 256 64 278.6l11.3-11.3L256 86.6 436.7 267.3 448 278.6 470.6 256l-11.3-11.3-192-192zm0 192L256 233.4l-11.3 11.3-192 192L41.4 448 64 470.6l11.3-11.3L256 278.6 436.7 459.3 448 470.6 470.6 448l-11.3-11.3-192-192z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faChevronsUp = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;